import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13 2a5 5 0 0 0-1 9.898s.341.102 1 .102c.576 0 1-.102 1-.102A5 5 0 0 0 13 2zm-2 2h3.5l.021 1H12v1h1a2 2 0 1 1-2 2h1a1 1 0 1 0 1-1h-2V4zM2 9v14.002C2 24.094 2.906 25 3.998 25h18.016A2.003 2.003 0 0 0 24 23.014V9h-2v14H4V9H2zm10 5v4h-2l3 4 3-4h-2v-4h-2z" }, null, -1)
  ])))
}
export default { render: render }